import { useSyncExternalStore } from 'react';

import {
  isExpectingSessionRoutineRuns,
  subscribeSessionRoutineRunsExpectation,
} from './session-routine-runs-expectation';

/** True briefly after session create while event-triggered runs may still appear. */
export const useExpectSessionRoutineRuns = (sessionId: string | undefined): boolean =>
  useSyncExternalStore(
    subscribeSessionRoutineRunsExpectation,
    () => isExpectingSessionRoutineRuns(sessionId),
    () => false
  );
